<a *ngIf="(quantity$ | async)  else oldStoreCart"
   [routerLink]="{ cxRoute: 'cart' } | cxUrl"
   [tabIndex]="-1"
   class="d-flex justify-content-center flex-column highlightable-header-tab py-4 ms-3 ms-md-5 focusable ds-color--grey-4">
  <em [tabIndex]="0"
      class="ds-icon--cart focusable__element position-relative"></em>
  <em *ngIf="quantity$ | async" class="count"></em>
</a>
<ng-template #oldStoreCart>
  <a href="https://www.sapstore.com/checkout/v2/"
     [tabIndex]="-1"
     class="d-flex justify-content-center flex-column highlightable-header-tab py-4 ms-4 ms-md-5 focusable ds-color--grey-4">
    <em [tabIndex]="0" [attr.title]="'cart.ariaLabel' | cxTranslate" role="link"
        class="ds-icon--cart focusable__element position-relative"></em>
  </a>
</ng-template>
